import { config } from 'config/config';
import getConfig from 'next/config';
import { isConPlatform } from 'utils';
import { ReduxPageContext } from 'src/store';
import { Router } from 'next/router';

const {
  HOME_PUBLIC_TITLE,
  HOME_PUBLIC_DESCRIPTION,
  LOGIN_TITLE,
  LOGIN_DESCRIPTION,
} = getConfig().publicRuntimeConfig;

export const removeWhitespaces = (str: string) => str.replace(/\s+/g, '');

export const absPoints = (points: number) =>
  isConPlatform ? Math.abs(points) : points;

export const getSeoTags = (router: Router, isUserLogged: boolean) => {
  const meta = {
    title: HOME_PUBLIC_TITLE,
    description: HOME_PUBLIC_DESCRIPTION,
  };

  if (isUserLogged) meta.title = config.APP.NAME;
  
  switch (router.asPath) {
    case '/login':
      meta.title = LOGIN_TITLE;
      meta.description = LOGIN_DESCRIPTION;
      break;
    case '/':
    default:
      break;
  }

  return meta;
};

export const getUserAuthStatus = (ctx: ReduxPageContext) => {
  const accessToken = ctx.store.getState().auth.accessToken;

  return !!accessToken;
};
